export const colors = {
  primaryColor: "#16c79a",
  grey: "#aaaaaa",
  black: "#323232",
};
